const CONSTANTS = {
  JulyDate: "2023-07-10",
  PercentageTooltipText: "The % +/- is related to last month compared to the previous month."
};

export default CONSTANTS;